/**
 * The Master Services Agreement -- the ONE agreement (Jake, 2026-10-20).
 *
 *   GET  /api/distributors/:id/agreement-acceptance     (same tenant: status)
 *   POST /api/distributors/:id/agreement-acceptance     (Owner: confirm)
 *
 * The confirm writes ONE record (the acceptance row AND the distributor's
 * msa_* columns) that the dashboard, Compliance and the launch gate all read.
 */
import api from './api'

export function getAgreementStatus(distributorId) {
  return api.get(`/api/distributors/${distributorId}/agreement-acceptance`)
}

/**
 * @param {number} distributorId
 * @param {{agreement_version: string, signer_name: string,
 *          signer_title: string, authority_attested: true}} confirmation
 */
export function confirmAgreement(distributorId, confirmation) {
  return api.post(
    `/api/distributors/${distributorId}/agreement-acceptance`,
    confirmation
  )
}

/**
 * Who is signed in, for a PUBLIC page that has no router-guard hydration
 * (/legal/agreement). The /auth/me payload: account_id, capabilities,
 * distributor ({id} or null), session_is_anonymous_storefront.
 */
export function getSession() {
  return api.get('/auth/me')
}

/** The stored bearer token, or null (storage may be unavailable). */
export function storedSessionToken() {
  try {
    return localStorage.getItem('token') || null
  } catch {
    return null
  }
}
